import React from 'react'
import PropTypes from 'prop-types'

import RegistrationForm from '~/pages/Signup/SignUpV2/Registration/Form'
import RegistrationHeader from '~/pages/Signup/SignUpV2/Registration/Header'

const SignUpV3Registration = props => {
  const {
    isMobile,
    promoCode,
  } = props

  return (
    <div className={`max-w-87.5 flex flex-col mx-auto md:p-0 pb-15 px-4 md:px-0 pt-12 ${isMobile ? 'flex-col-reverse' : 'flex-col'}`}>
      <div>
        <RegistrationHeader
          isMobile={isMobile}
        />
        <RegistrationForm promoCode={promoCode} />
      </div>
    </div>
  )
}

SignUpV3Registration.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  promoCode: PropTypes.string,
}

SignUpV3Registration.defaultProps = {
  promoCode: '',
}

const Memoized = React.memo(SignUpV3Registration)
export default Memoized
